<template>
  <div>
    <el-dialog :title="data.title" :visible.sync="showModal" width="500px" class="quote_modal" :append-to-body='true' :loading="loading" :before-close="handleClose">
      <div class="quote_modal_phone">{{ data.sendModel }} <span>{{ number }}</span></div>
      <div>
        <el-input placeholder="输入验证码" v-model="verifyCode" maxlength='6'>
          <template slot="prepend">{{ data.prepend }}</template>
        </el-input>
      </div>
      <div class="quote_modal_countdown" v-if='timer'><span>{{ seconds }}</span> 秒后再次发送</div>
      <div class="quote_modal_countdown" @click="sendCode" v-else v-loading="codeLoading"><em style="cursor: pointer;">发送验证码</em></div>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleModalSubmit" :loading="loading">确认</el-button>
      <el-button @click="handleClose">取消</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import {getCodeByValid, tencentCaptchaApi, loginReg} from "src/request/apis";
import Cookies from "js-cookie";
import {tokenKey, phoneReg} from "utils";
import {host} from "src/config";

export default {
  name: "TicLoginVerifyCode",
  props: {
    data: {
      type: Object,
      default() {
        return {
          title: '验证手机号',
          sendModel: '已发送到手机号：+86',
          prepend: '手机验证码'
        }
      }
    },
    number: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    captchaAppId: {
      type: String,
      default: ''
    },
    captchaShow: {
      type: Boolean,
      default: true
    },
    env: {
      type: String,
      default: 'local'
    },
    handleSubmit: {
      type: Function,
      default: null
    },
    loginSuccess: {
      type: Function
    },
    verifyParams: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      pageInfo: {},
      loading: false,
      showModal: false,
      verifyCode: '',
      seconds: 59,
      timer: null,
      codeLoading: false,
      host: host(this.env),
      phoneReg,
      domain: host(this.env).domain,
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          if (this.seconds === 59) {
            this.sendCode()
          } else {
            this.showModal = val
          }
        } else {
          this.showModal = val
          this.handleClose()
        }
      }
    }
  },
  methods: {
    sendCode() {
      if (this.captchaShow) {
        this.showCaptcha()
        return
      }
      this.showModal = true
      this.toSendCode()
    },
    /* 腾讯安全盾调用方 */
    showCaptcha() {
      try {
        let captcha = new window.TencentCaptcha(this.captchaAppId, (res) => {
          if (res.ret === 0) {
            const data = {
              ticket: res.ticket,
              randstr: res.randstr,
              captchaAppId: this.captchaAppId
            }
            this.showModal = true
            this.toSendCode(data)
          } else if (res.ret === 2) {
            this.handleClose()
            // 用户主动关闭验证码
          }
        });
        captcha.show();
      } catch (e) {
        this.toSendCode()
      }
    },
    toSendCode(txData) {
      this.codeLoading = true
      const data = Object.assign({
        projectName: 'ticMember',
        verifyMode: this.phoneReg.test(this.number) ? 'phone' : 'email',
        verifyNumber: this.number,
        verifyType: 3,
        tencentVerify: txData
      }, this.verifyParams)
      getCodeByValid(data, this.host.mdoUrl)
        .then((res) => {
          this.codeLoading = false
          if (res.resultCode === '0') {
            this.timer = setInterval(() => {
              if (this.seconds > 1) {
                this.seconds -= 1
              } else {
                clearInterval(this.timer)
                this.timer = null
                this.seconds = 59
              }
            }, 1000)
          } else {
            this.$message.error(res.resultMsg)
          }
        })
        .catch((e) => {
          this.codeLoading = false
        })
    },
    handleModalSubmit() {
      if (!this.verifyCode) {
        this.$message.error('请输入验证码')
        return
      }
      if (this.handleSubmit) {
        this.loading = true
        this.handleSubmit(this)
        return
      }
      this.loading = true
      let arr = {
        verifyCode: this.verifyCode,
        verifyNumber: this.number,
        verifyType: 3,
        verifyMode: this.phoneReg.test(this.number) ? 'phone' : 'email',
        accountType: this.phoneReg.test(this.number) ? 'phone' : 'email',
        accountNo: this.number,
        regFrom: location.href
      }
      loginReg(Object.assign(arr, this.verifyParams), this.host.mdoUrl)
        .then((res) => {
          if (res.resultCode === '0') {
            this.login(res)
          } else {
            this.loading = false
          }
        })
        .catch((e) => {
          console.log(e);
          this.loading = false
        })
    },
    /* 登录成功之后的操作 */
    login(res) {
      this.loading = false
      this.token = res.data.token
      const token = res.data.token
      const count = res.data.count || 0
      if (!this.domain.includes('localhost')) {
        Cookies.set(tokenKey, token, {domain: '.sgsonline.com.cn'})
        Cookies.set(tokenKey, token, {domain: '.sgsmall.com.cn'})
        Cookies.set('CARTNUMBER', count, { domain: '.sgsonline.com.cn' })
        Cookies.set('CARTNUMBER', count, { domain: '.sgsmall.com.cn' })
      } else {
        // Cookies.set(tokenKey, token)
        // Cookies.set('CARTNUMBER', count)
        Cookies.set(tokenKey, token, {domain: '.sgsonline.com.cn'})
        Cookies.set(tokenKey, token, {domain: '.sgsmall.com.cn'})
        Cookies.set('CARTNUMBER', count, { domain: '.sgsonline.com.cn' })
        Cookies.set('CARTNUMBER', count, { domain: '.sgsmall.com.cn' })
      }
      this.handleClose()
      this.$emit('loginSuccess')
      if (this.loginSuccess) this.loginSuccess()
    },
    handleClose() {
      this.verifyCode = ''
      this.showModal = false
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss">
.quote_modal {
  .el-dialog {
    border-radius: 20px;
  }

  .el-dialog__header {
    text-align: center;
    color: #333;
    font-weight: bold;
    font-size: 16px;
    border-bottom: 1px solid #E5E5E5;
  }

  .el-dialog__body {
    padding: 0;
    margin: 30px auto;
    width: 300px;
  }

  .el-dialog__footer {
    text-align: center;
  }

  input {
    border: 1px solid #ddd !important;
  }

  .quote_modal_phone {
    font-size: 14px;
    color: #878787;
    padding-bottom: 20px;
    text-align: center;
  }

  .quote_modal_countdown {
    margin-top: 34px;
    font-size: 14px;
    color: #878787;
    text-align: center;

    span {
      color: #ca4303;
    }
    em {
      font-style: normal;
    }
  }

}
</style>